var map = {
	"./d01.png": 61,
	"./d02.png": 62,
	"./d03.png": 63,
	"./d04.png": 64,
	"./d05.png": 65,
	"./d06.png": 66,
	"./d07.png": 67,
	"./d08.png": 68,
	"./d09.png": 69,
	"./d10.png": 70,
	"./d11.png": 71,
	"./d12.png": 72,
	"./d13.png": 73,
	"./d14.png": 74,
	"./d15.png": 75,
	"./d16.png": 76,
	"./d17.png": 77,
	"./d18.png": 78
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;